(function($){

  $(".main-menu .slide-link a").click(function(e) {
    e.preventDefault();
    var offset = -100;
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top + offset},'slow');
  });

  

})(jQuery);